export const GLOBAL_PARTNER_DATA = 'globalPartnerData'

export const REQUEST_GLOBAL_PARTNER_DATA = 'REQUEST_GLOBAL_PARTNER_DATA'

export const YEAR_WHEN_GP_APPEARS = 2024
